// import React from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import PostListView from "./components/PostListView";
// import MagazinesPage from "./components/MagazinesPage";
// import Navbar from "./components/Header/Navbar";
// import PostPage from "./components/PostPage/PostPage";
// import Layout from "./admin/layout"; // ✅ Ensure Layout wraps all admin routes
// import CategoriesPagelist from "./categories/CategoriesPagelist";
// import CategoryPostsPage from "./categories/CategoryPostsPage";
// // Admin Dashboard
// import Dashboard from "./admin/page";

// // Post Management
// import PostFormContextProvider from "./admin/posts/form/contexts/PostFormContext";
// import Postedit from "./admin/posts/Postedit";
// import FormPage from "./admin/posts/form/FormPage";

// // Category Management
// import CategoryFormContextProvider from "./admin/categories/form/contexts/CategoryFormContext";
// import CategoriesPage from "./admin/categories/CategoriesPage";
// import CategoryFormPage from "./admin/categories/form/CategoryFormPage";

// // Author Management
// import AuthorFormContextProvider from "./admin/authors/form/contexts/AuthorFormContext";
// import AuthorsPage from "./admin/authors/AuthorsPage";
// import AuthorFormPage from "./admin/authors/form/AuthorFormPage";

// // Archives Management
// import ArchiveFormContextProvider from "./admin/archives/form/contexts/ArchiveFormContext";
// import ArchiveListView from "./admin/archives/components/ArchiveListView"; // equivalent to Postedit
// import ArchiveFormPage from "./admin/archives/form/FormPage";

// const App = () => {
//   return (
//     <Router>
//       <Navbar /> {/* Always Display Navbar */}
//       <Routes>
//         {/* Public Routes */}
//         <Route path="/" element={<PostListView />} />
//         <Route path="/posts/:postId" element={<PostPage />} />

//         <Route path="/magazines" element={<MagazinesPage />} />

//         {/* Admin Routes (Wrapped in Layout) */}
//         <Route path="/admin/*" element={<Layout />}>
//           <Route index element={<Dashboard />} />

//           {/* Posts */}
//           <Route path="posts" element={<Postedit />} />
//           <Route
//             path="posts/form"
//             element={
//               <PostFormContextProvider>
//                 <FormPage />
//               </PostFormContextProvider>
//             }
//           />

//           {/* Categories */}
//           <Route
//             path="categories"
//             element={
//               <CategoryFormContextProvider>
//                 <CategoriesPage />
//               </CategoryFormContextProvider>
//             }
//           />
//           <Route
//             path="categories/form"
//             element={
//               <CategoryFormContextProvider>
//                 <CategoryFormPage />
//               </CategoryFormContextProvider>
//             }
//           />

//           {/* Authors */}
//           <Route
//             path="authors"
//             element={
//               <AuthorFormContextProvider>
//                 <AuthorsPage />
//               </AuthorFormContextProvider>
//             }
//           />
//           <Route
//             path="authors/form"
//             element={
//               <AuthorFormContextProvider>
//                 <AuthorFormPage />
//               </AuthorFormContextProvider>
//             }
//           />

//           {/* Archives */}
//           <Route
//             path="archives"
//             element={
//               <ArchiveFormContextProvider>
//                 <ArchiveListView />
//               </ArchiveFormContextProvider>
//             }
//           />
//           <Route
//             path="archives/form"
//             element={
//               <ArchiveFormContextProvider>
//                 <ArchiveFormPage />
//               </ArchiveFormContextProvider>
//             }
//           />
//         </Route>

//         <Route path="/categorie" element={<CategoriesPagelist />} />
//         <Route path="/categorie/:categoryId" element={<CategoryPostsPage />} />
//       </Routes>
//     </Router>
//   );
// };

// export default App;

import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PostListView from "./components/PostListView";
import MagazinesPage from "./components/MagazinesPage";
import Navbar from "./components/Header/Navbar";
import PostPage from "./components/PostPage/PostPage";
import Layout from "./admin/layout";
import CategoriesPagelist from "./categories/CategoriesPagelist";
import CategoryPostsPage from "./categories/CategoryPostsPage";
// Admin Dashboard
import Dashboard from "./admin/page";

// Post Management
import PostFormContextProvider from "./admin/posts/form/contexts/PostFormContext";
import Postedit from "./admin/posts/Postedit";
import FormPage from "./admin/posts/form/FormPage";

// Category Management
import CategoryFormContextProvider from "./admin/categories/form/contexts/CategoryFormContext";
import CategoriesPage from "./admin/categories/CategoriesPage";
import CategoryFormPage from "./admin/categories/form/CategoryFormPage";

// Author Management
import AuthorFormContextProvider from "./admin/authors/form/contexts/AuthorFormContext";
import AuthorsPage from "./admin/authors/AuthorsPage";
import AuthorFormPage from "./admin/authors/form/AuthorFormPage";

// Archives Management
import ArchiveFormContextProvider from "./admin/archives/form/contexts/ArchiveFormContext";
import ArchiveListView from "./admin/archives/components/ArchiveListView";
import ArchiveFormPage from "./admin/archives/form/FormPage";

// Newsletters Management
import NewsletterFormContextProvider from "./admin/newsletters/form/contexts/NewsletterFormContext";
import NewsletterListView from "./admin/newsletters/components/NewsletterListView";
import NewsletterFormPage from "./admin/newsletters/form/FormPage";

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PostListView />} />
        <Route path="/posts/:postId" element={<PostPage />} />
        <Route path="/magazines" element={<MagazinesPage />} />
        <Route path="/categorie" element={<CategoriesPagelist />} />
        <Route path="/categorie/:categoryId" element={<CategoryPostsPage />} />

        {/* Admin Routes (Wrapped in Layout) */}
        <Route path="/admin/*" element={<Layout />}>
          <Route index element={<Dashboard />} />

          {/* Posts */}
          <Route path="posts" element={<Postedit />} />
          <Route
            path="posts/form"
            element={
              <PostFormContextProvider>
                <FormPage />
              </PostFormContextProvider>
            }
          />

          {/* Categories */}
          <Route
            path="categories"
            element={
              <CategoryFormContextProvider>
                <CategoriesPage />
              </CategoryFormContextProvider>
            }
          />
          <Route
            path="categories/form"
            element={
              <CategoryFormContextProvider>
                <CategoryFormPage />
              </CategoryFormContextProvider>
            }
          />

          {/* Authors */}
          <Route
            path="authors"
            element={
              <AuthorFormContextProvider>
                <AuthorsPage />
              </AuthorFormContextProvider>
            }
          />
          <Route
            path="authors/form"
            element={
              <AuthorFormContextProvider>
                <AuthorFormPage />
              </AuthorFormContextProvider>
            }
          />

          {/* Archives */}
          <Route
            path="archives"
            element={
              <ArchiveFormContextProvider>
                <ArchiveListView />
              </ArchiveFormContextProvider>
            }
          />
          <Route
            path="archives/form"
            element={
              <ArchiveFormContextProvider>
                <ArchiveFormPage />
              </ArchiveFormContextProvider>
            }
          />

          {/* Newsletters */}
          <Route
            path="newsletters"
            element={
              <NewsletterFormContextProvider>
                <NewsletterListView />
              </NewsletterFormContextProvider>
            }
          />
          <Route
            path="newsletters/form"
            element={
              <NewsletterFormContextProvider>
                <NewsletterFormPage />
              </NewsletterFormContextProvider>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
